import { ShieldCheck, Hammer, Ship, Settings } from "lucide-react";
import React from "react";

const features = [
  {
    icon: <Ship size={32} className="text-[#009fe3]" />,
    title: "30 Yıllık Tecrübe",
    desc: "Denizcilik sektöründe güvenin ve uzmanlığın adı.",
  },
  {
    icon: <Hammer size={32} className="text-[#009fe3]" />,
    title: "Kaliteli Üretim",
    desc: "Fiber, polyester ve ahşap tekne üretiminde yüksek standartlar.",
  },
  {
    icon: <Settings size={32} className="text-[#009fe3]" />,
    title: "Tam Hizmet",
    desc: "Tekne bakım, boya, kışlama ve römork taşıma hizmetleri tek çatı altında.",
  },
  
  {
    image: "",
    icon: <ShieldCheck size={32} className="text-[#009fe3]" />,
    title: "CE Sertifikalı",
    desc: "Tüm teknelerimiz Avrupa Birliği CE standartlarına uygun olarak üretilir.",
  },
];

const AboutPage: React.FC = () => {
  return (
    <div className="w-full bg-[#fdfaf6] text-gray-800 font-montserrat">
      {/* Üst Başlık */}
      <section className="text-center py-10 px-6 bg-[#002744] text-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-4 tracking-wide">Hakkımızda</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto opacity-80">
          Ayvalık Marin olarak denizcilik tutkumuzu, uzmanlığımızla birleştirerek sizin için eşsiz bir deneyim sunuyoruz.
        </p>
      </section>

      {/* İçerik */}
      <section className="max-w-7xl mx-auto py-20 px-6 grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6">
          <h2 className="text-3xl font-bold text-[#002744]">Biz Kimiz?</h2>
          <p className="text-lg leading-relaxed">
            Yıllardır Ayvalık’ta denizle iç içe yaşamı kolaylaştıran çözümler üretiyoruz.
            Üretimden bakıma, kışlamadan römork taşıma hizmetlerine kadar geniş bir yelpazede çalışıyoruz.
          </p>
          <p className="text-lg leading-relaxed">
            Teknolojiyi takip ediyor, kaliteyi ön planda tutuyoruz. Müşteri memnuniyetini merkeze alarak,
            her zaman daha iyisini hedefliyoruz.

          </p>
        </div>
        <div className="rounded-xl overflow-hidden shadow-lg bg-blue-100">
          <img
            src="/images/ayvalik-marin-icons/aymar2.png"
            alt="Ayvalık Marin"
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
        </div>
      </section>

    <section className="bg-[#002744] text-white py-16 px-6">
    <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((item, index) => (
        <div
            key={index}
            className="bg-white text-gray-800 rounded-2xl p-6 shadow-md hover:shadow-xl transition-all flex flex-col items-start gap-2"
        >
        <div className="flex justify-between items-center w-full mb-2">
        <h3 className="text-xl font-bold text-[#002744]">{item.title}</h3>
        <div>
            {item.icon ? (
            item.icon
            ) : (
            <img
                src={item.image}
                alt={item.title}
                className="w-12 h-12 object-contain"
            />
            )}
        </div>
        </div>


            <p className="text-sm leading-relaxed">{item.desc}</p>
        </div>
        ))}
    </div>
    </section>



    </div>
  );
};

export default AboutPage;
